import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

import { AddWantedForm } from './AddWanted.types';

export const useAddWantedValidation = () => {
  const { formatMessage } = useLocale();

  const schema: yup.SchemaOf<AddWantedForm> = yup.object().shape({
    idPkds: yup
      .array()
      .min(1)
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    tkds: yup
      .array()
      .min(1)
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    serwerId: yup.string().required(formatMessage({ id: AppMessages['common.validation.required'] })),
    informacja: yup
      .string()
      .max(64, formatMessage({ id: AppMessages['wanted.addOwner.information.lengthError'] }))
      .required(formatMessage({ id: AppMessages['common.validation.required'] }))
      .test(
        'check comma not allowed',
        formatMessage({ id: AppMessages['wanted.addOwner.information.noComma'] }),
        (val) => {
          if (!val) return true;
          return !val.includes(',');
        },
      ),
  });

  return { schema };
};
